import { Flex, Group, Paper, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { WosSyncButton } from '@/module/Dashboard/components/WosSyncButton';
import { ProfileDetails } from '@/module/Dashboard/model/DashboardTypes';

import { ResearcherIdAddButton } from './components/ResearcherIdAddButton';
import { WosResearcherIdPill } from './components/WosResearcherIdPill';

export interface WosResearcherSyncProps {
  profileDetails: ProfileDetails;
}

export function WosResearcherSync({ profileDetails }: WosResearcherSyncProps) {
  const { researcherIds } = profileDetails;
  const { t } = useTranslation();

  return (
    <Paper
      component="section"
      aria-label={t('dashboard.cards.wos')}
      flex={1}
      p="md"
      mih="200px"
    >
      <Stack>
        <Flex justify="space-between">
          <ResearcherIdAddButton />

          <WosSyncButton />
        </Flex>

        <Text>WoS researcher id revendicate:</Text>
        {researcherIds != null ? (
          <Group>
            {researcherIds.map(researcherId => (
              <WosResearcherIdPill
                key={researcherId}
                researcherId={researcherId}
              />
            ))}
          </Group>
        ) : (
          ''
        )}
      </Stack>
    </Paper>
  );
}
